export enum AttractSource {
  EXCHANGE = 'exchange2',
  PAYMENT = 'payment2',
  REGISTER = 'register2',
  TASTE_REGISTER = 'taste-register',
  PERSON_PAYMENT = 'person-payment',
  TEAM_PAYMENT = 'team-payment2',
}
